import axios from "../axios";

const createPartner = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('partner/createPartner', data ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default createPartner;
